import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Bounce, toast, ToastContainer } from "react-toastify";
import * as API from "../../utils/service";
import { StaticAPI } from "../../utils/StaticAPI";
import { isNullOrUndefined } from "../../utils/utils";
import {
  DAO_DIGIO_URL,
  StaticRouterLinks,
} from "../../utils/StaticRouterLinks";
import Header from "../../components/Header";
import { useFormik } from "formik";
import { Dialog } from "@mui/material";
import ErrorToster from "../../components/TosterComponents/ErrorToster";

export default function DocumentationLayout() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [clientDetails, setClientDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);
  const handleEsign = async () => {
    try {
      setLoader(true);

      const response = await API.getMethod(StaticAPI?.submit);
      const { callback, access_token } = response;
      const { entity_id, id } = access_token;
      const emailId = localStorage.getItem("emailId");

      const redirectBaseUrl = `${window.location.origin}/account-closure`;
      const url = `${DAO_DIGIO_URL}/${entity_id}/${callback}/${
        clientDetails?.Email
      }?token_id=${id}&redirect_url=${encodeURIComponent(
        `${redirectBaseUrl}?callback=${callback}`
      )}`;
      setLoader(false);
      console.log(url);
      window.location.href = url;
    } catch (error) {
      console.error("Error in handleEsign:", error);
      setLoader(false);
    }
  };
  const accountOptionForm = useFormik({
    initialValues: {
      close_trading_account: false,
      close_demat_account: false,
      signaturImage: null,
      cmrCopy: null,
      reason: "",
      balanceRemaining: "",
      target_dp_id: "",
      target_bo_id: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        try {
          const accountResponse = await API.daoPostMethod(
            StaticAPI.updateAccount,
            {
              close_trading_account: values.close_trading_account,
              close_demat_account: values.close_demat_account,
              reason: values.reason,
              balanceRemaining: values.balanceRemaining,
              target_dp_id: values.target_dp_id,
              target_bo_id: values.target_bo_id,
            }
          );
          toast.success("Account action completed successfully!");
        } catch (error) {
          console.error("Error completing account action:", error);
          toast.error("Failed to complete account action. Please try again.");
          return;
        }

        await handleEsign();
      } catch (error) {
        console.error("Unexpected error:", error);
        toast.error("An unexpected error occurred. Please try again.");
      }
    },
  });

  useEffect(() => {
    let getMethodWithQueryHelper = () => {
      // setLoader(true);
      API.getMethod(StaticAPI.clientDetails)
        .then((response) => {
          if (!isNullOrUndefined(response)) {
            setClientDetails(response);
            setLoader(false);
          } else {
            // localStorage.clear();
            // navigate(StaticRouterLinks.home);
          }
        })
        .catch((error) => {
          setLoader(false);
          // localStorage.clear();
          // navigate(StaticRouterLinks.home);
        });
    };
    if (!isNullOrUndefined(localStorage.getItem("token"))) {
      getMethodWithQueryHelper();
    } else {
      localStorage.clear();
      navigate(StaticRouterLinks.home);
    }
  }, []);

  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        closeButton={false}
        transition={Bounce}
        limit={1}
      />
      <div className="relative w-screen  scroll-hide ">
        <div className={` md:block`}>
          <Header
            clientDetails={clientDetails}
            setDialogContent={setDialogContent}
            setOpen={setOpen}
          />
        </div>
        <div
          className={`flex flex-row justify-center items-center md:min-h-screen md:px-[38px]`}
        >
          {loader ? (
            <div className="flex md:block justify-center items-center h-screen md:h-full">
              <div className="loaderWithPrimaryColour"></div>
            </div>
          ) : (
            <Outlet
              context={{
                accountOptionForm,
                clientDetails,
                setDialogContent,
                setOpen,
              }}
            />
          )}
        </div>
      </div>

      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          setDialogContent(null);
        }} // PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        {dialogContent}
      </Dialog>
    </>
  );
}
